import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

// Routes are now defined in app-routing.module.ts since this module is no longer lazy-loaded

@NgModule({
    imports: [RouterModule.forChild([])],
    exports: [RouterModule]
})
export class HomePluginRoutingModule { }
